import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function AlertasPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="dashboard"
      subsectionPath="alertas"
    />
  );
}
